import {
    Box,
    Heading,
    Table,
    Tbody,
    Tr,
    Td,
    Th,
    useToast,
    Thead,
    Text,
    Tooltip,
    Badge,
    VStack,
    Button,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { react_api } from "../../config";
import { HTTP_STATUS_CODES } from "../../GrinsCostant";
import { CASE_TYPE } from '../../CaseTypeCostant';
import logout from "../../services/authService";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors";
import { useSession } from '../../SessionContext';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ToDeprecateDatasetList() {
    const toast = useToast();
    const { t } = useTranslation();
    const { clearSessionData } = useSession();
    const navigate = useNavigate();
    const [catalog, setCatalog] = useState([]);
    const [message, setMessage] = useState("");

    const axiosInstance = createAxiosInstance(async (instance) => {
        logout(t, clearSessionData, navigate, toast, instance);
    });

    useEffect(() => {
        const fetchCatalog = async () => {
            try {
                const requestPayload = {
                    BearerToken: sessionStorage.getItem("token"),
                    username: sessionStorage.getItem("username"),
                    caseType: CASE_TYPE.CATALOG_PUBLIC_DATASETS,
                };

                const options = {
                    headers: { 'Content-Type': 'application/json' }
                };

                const response = await axiosInstance.post(`${react_api}/privateCatalog/getCatalogADP`, requestPayload, options);
                const result = response.data;

                if (result.status === HTTP_STATUS_CODES.OK) {
                    setCatalog(result.catalog);
                } else {
                    setMessage(result.message);
                    toast({
                        title: t('toastMsg.error'),
                        description: t(`messageBE.${result.message}`),
                        position: "top",
                        status: 'error',
                        duration: 4000,
                        isClosable: true
                    });
                }
            } catch (error) {
                toast({
                    title: t('toastMsg.callError'),
                    description: String(error),
                    position: "top",
                    status: 'warning',
                    duration: 4000,
                    isClosable: true
                });
            }
        };

        fetchCatalog();
    }, []);

    const handleDeprecate = (dataset) => {
        toast({
            title: t('Deprecating'),
            description: `${dataset.TBL_NAME} ${t('will be deprecated')}`,
            position: "top",
            status: "info",
            duration: 3000,
            isClosable: true
        });

        // Implement deprecation logic here (e.g., POST to a deprecation endpoint)
    };

    return (
        <Box h="100%" w="100%">
            <Heading size='md' color="rgba(11,78,90,255)">
                {/* {t('home.publicDataset')} */}
                Dataset to Deprecate
            </Heading>
            <Box overflowY="auto" h="260px" boxShadow="lg" borderRadius="10px" position="relative" zIndex={0}>
                <Table size="sm" variant="striped" bg="white">
                    <Thead bg="#0888BE" position="sticky" top="0" zIndex={1}>
                        <Tr>
                            <Th color="white">Dataset</Th>
                            <Th color="white">{t('catalog.dataset.table.categories')}</Th>
                            <Th color="white">{t('catalog.dataset.table.description')}</Th>
                            <Th color="white">Manager</Th>
                            <Th color="white">Action</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {catalog.length > 0 ? (
                            catalog.map((item, index) => (
                                <Tr key={index}>
                                    <Td whiteSpace="normal" wordBreak="break-word">{item.TBL_NAME}</Td>
                                    <Td wordBreak="break-word" maxW="200px">
                                        <VStack spacing={2} align="start">
                                            {item.category.map((cat, idx) => (
                                                <Tooltip key={idx} label={cat} hasArrow>
                                                    <Badge
                                                        color="black"
                                                        border="1px solid #0888BE"
                                                        bg="transparent"
                                                        borderRadius="md"
                                                        px={1}
                                                        py={0}
                                                        maxW="150px"
                                                        overflow="hidden"
                                                        textOverflow="ellipsis"
                                                        whiteSpace="nowrap"
                                                        display="inline-block"
                                                    >
                                                        {cat}
                                                    </Badge>
                                                </Tooltip>
                                            ))}
                                        </VStack>
                                    </Td>
                                    <Td whiteSpace="normal" wordBreak="break-word">
                                        <Tooltip
                                            label={item.description.length > 200 ? item.description : null}
                                            hasArrow
                                            placement="bottom-start"
                                            openDelay={300}
                                            maxW="1000px"
                                            whiteSpace="normal"
                                        >
                                            <Text as="span" cursor="pointer">
                                                {item.description.length > 200 ? (
                                                    <>
                                                        {item.description.substring(0, 150)}
                                                        <Text as="span" color="green.500"> ► </Text>
                                                    </>
                                                ) : (
                                                    item.description
                                                )}
                                            </Text>
                                        </Tooltip>
                                    </Td>
                                    <Td whiteSpace="normal" wordBreak="break-word">{item.OWNER}</Td>
                                    <Td>
                                        <Button size="sm" colorScheme="red" onClick={() => handleDeprecate(item)}>
                                            {t('Deprecate')}
                                        </Button>
                                    </Td>
                                </Tr>
                            ))
                        ) : (
                            <Tr>
                                <Td colSpan={5}>
                                    <Text fontSize="lg" color="rgba(11,78,90,255)">
                                        {message ? t(`messageBE.${message}`) : ''}
                                    </Text>
                                </Td>
                            </Tr>
                        )}
                    </Tbody>
                </Table>
            </Box>
        </Box>
    );
}
